export const GET_GOSI_TERMINATION_REASONS = 'GET_GOSI_TERMINATION_REASONS'
export const GET_GOSI_TERMINATION_REASONS_PENDING = 'GET_GOSI_TERMINATION_REASONS_PENDING'
export const GET_GOSI_TERMINATION_REASONS_FULFILLED = 'GET_GOSI_TERMINATION_REASONS_FULFILLED'
export const GET_GOSI_TERMINATION_REASONS_REJECTED = 'GET_GOSI_TERMINATION_REASONS_REJECTED'

export const TERMINATE_EMPLOYEE = 'TERMINATE_EMPLOYEE'
export const TERMINATE_EMPLOYEE_PENDING = 'TERMINATE_EMPLOYEE_PENDING'
export const TERMINATE_EMPLOYEE_FULFILLED = 'TERMINATE_EMPLOYEE_FULFILLED'
export const TERMINATE_EMPLOYEE_REJECTED = 'TERMINATE_EMPLOYEE_REJECTED'
